import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useQueryString from '@hooks/useQueryString';
import {
  CapaQuotationDetailedServiceType,
  CapaQuotationServiceType
} from '@generated/graphql';
import useRequest from '@hooks/useRequest';
import { RootState } from '@modules/index';
import RequestPresenter from './NewRequestPresenter';
import { RequestQueryString } from './types';

const RequestContainer: React.FC = () => {
  const {
    query: { serviceType, detailedServiceType }
  } = useQueryString<RequestQueryString>();
  const currentServiceType = useSelector<RootState, CapaQuotationServiceType>(
    (state) => state.request.serviceType
  );
  const currentDetailedServiceType = useSelector<
    RootState,
    CapaQuotationDetailedServiceType | undefined
  >((state) => state.request.detailedServiceType ?? undefined);
  const { onUpdateRfqInfo, initialState } = useRequest();
  const history = useHistory();

  useEffect(() => {
    if (serviceType && currentServiceType !== serviceType) {
      onUpdateRfqInfo({
        ...initialState,
        serviceType
      });
    }
  }, [serviceType, initialState, onUpdateRfqInfo, currentServiceType]);

  useEffect(() => {
    if (
      history.location.search &&
      detailedServiceType &&
      currentDetailedServiceType !== detailedServiceType
    ) {
      onUpdateRfqInfo({
        detailedServiceType
      });
    }
  }, [
    detailedServiceType,
    onUpdateRfqInfo,
    currentDetailedServiceType,
    history.location.search
  ]);

  return <RequestPresenter />;
};

export default RequestContainer;
